import React from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
  Button,
  Stack,
} from "@mui/material";

const AccountList = ({ accounts = [], onEdit, onDelete }) => {
  if (!accounts.length) {
    return <Typography color="text.secondary">No accounts found.</Typography>;
  }

  return (
    <Grid container spacing={2}>
      {accounts.map((account) => (
        <Grid item xs={12} md={6} lg={4} key={account.id}>
          <Card>
            <CardContent>
              <Typography variant="h6">{account.accountName}</Typography>
              <Typography variant="body2" color="text.secondary">
                {account.accountCode} • {account.mainType}
              </Typography>

              <Stack direction="row" spacing={1} sx={{ mt: 1, mb: 2 }}>
                <Chip label={account.subType || "general"} size="small" />
                <Chip
                  label={account.status || "active"}
                  size="small"
                  color="info"
                />
              </Stack>

              <Typography variant="body2">
                Display Name: {account.displayName || "-"}
              </Typography>

              <Box sx={{ mt: 2 }}>
                <Stack direction="row" spacing={1}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => onEdit?.(account)}
                  >
                    Edit
                  </Button>
                  <Button
                    size="small"
                    color="error"
                    variant="outlined"
                    onClick={() => onDelete?.(account.id)}
                  >
                    Delete
                  </Button>
                </Stack>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AccountList;
